import { useSession } from '@/hooks/useSession';
import { isFullAdmin } from '@/types/session';

/** Returns true when the current user has the full_admin or director PG role. */
export function useIsSuperAdmin(): boolean {
  const { user } = useSession();
  return isFullAdmin(user);
}
